import { render, staticRenderFns } from "./contratoVencendoCard.vue?vue&type=template&id=298f32e2&scoped=true"
import script from "./contratoVencendoCard.vue?vue&type=script&lang=js"
export * from "./contratoVencendoCard.vue?vue&type=script&lang=js"
import style0 from "./contratoVencendoCard.vue?vue&type=style&index=0&id=298f32e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f32e2",
  null
  
)

export default component.exports